import { Component, input, OnInit, output } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-go-back',
  templateUrl: './go-back.component.html',
  styleUrls: ['./go-back.component.scss'],
  standalone: false
})
export class GoBackComponent implements OnInit {

  onGoBack = output<void>();
  overrideBack = input<boolean>(false);

  constructor(private location: Location) { }

  ngOnInit() {
  }

  onBack() {
    if (this.overrideBack()) {
      this.onGoBack.emit();
    } else {
      this.location.back();
    }
  }

}
